<style scoped>
</style>
<template>
  <list ref="list"></list>
</template>

<script>
  import list from "../../../components/approval/list";
  export default {
    name: "forwarding",//抄送
    components: {list},
  }
</script>
